import React from "react";
import LoginOrRegisterForm from "../components/LoginRegisterForm";

const RegisterPage = () => {
  return <LoginOrRegisterForm loginOrRegister={"register"} />;
};

export default RegisterPage;
